import { closePopup } from '../helpers';
import { parseRequestUrl, replaceRouter } from '../router';

function popStateListener(event) {
  const { routePath, query, state } = parseRequestUrl();

  closePopup();
  replaceRouter(state, null, routePath);
}

/**
 * 백버튼 history back 활성화
 */
export const setEnableBackControl = () => {
  window.removeEventListener('popstate', popStateListener);
};

/**
 * 백버튼 history back 비활성화
 */
export const setDisableBackControl = () => {
  window.addEventListener('popstate', popStateListener);
};
